
import theme from '@/config/theme';
import { Wrapper } from './styles';

export default {
  name: 'Heading',
  components: {
    Wrapper,
  },
  props: {
    bold: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
      validator(value: string) {
        return Object.keys(theme.colors).indexOf(value) !== -1;
      },
    },
    size: {
      type: Number,
      validator(value: number) {
        return [1, 2, 3, 4, 5, 6].indexOf(value) !== -1;
      },
    },
    title: String,
  },
};
